/**
 * This can be useful for vertical bars in inline contexts without having to
 * fight with formatjs/no-literal-string-in-jsx and so they are a bit more
 * visible in the component tree.
 */
export function VerticalBarLiteral() {
  return " | ";
}
